import uuid from 'lodash';
import { api } from '$app/api';

export const getGarageZoneShapes = () => api.get('/zones/areas/all').then((res) => res.data);

export const getCoveredOutbounds = (householdsThreshold = 80) => {
  let URL = `/zones/areas/download?householdsThreshold=${householdsThreshold}`;
  return api.get(URL).then((res) => res.data);
}



export const getDriverZoneShapes = () => api.get('/zones/areas/all?type=driver').then((res) => res.data);

function generateUUID() {
  // Public Domain/MIT
  let d = new Date().getTime(); // Timestamp
  // Time in microseconds since page-load or 0 if unsupported
  let d2 = (performance && performance.now && performance.now() * 1000) || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16; // random number between 0 and 16
    if (d > 0) {
      // Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      // Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function createDriverZone(newZone) {
  return api
    .post('/zones/areas', {
      ownerType: 'driver',
      name: newZone.name,
      lat: newZone.latitude,
      lng: newZone.longitude,
      ownerId: generateUUID(),
      metadata: newZone.metadata,
      segment: newZone.segment,
    })
    .then((res) => res.data);
}
